export const getMovies = (quantity) => {
    const films = [
        {title: 'Reservoir Dogs', id: 'tt0105236', gif: 'https://i.gifer.com/TvQ.gif'}, 
        {title: 'Groundhog Day', id: 'tt0107048', gif: 'https://i.gifer.com/Ourk.gif'}, 
        {title: 'Amelie', id: 'tt0211915', gif: 'https://i.gifer.com/EZjs.gif'}, 
        {title: 'Brokeback Mountain', id: 'tt0388795', gif: 'https://i.gifer.com/16c7.gif'}, 
        {title: 'Scott Pilgrim Vs. The World', id: 'tt0446029', gif: 'https://i.gifer.com/O6qx.gif'}, 
        {title: 'Léon', id: 'tt0110413', gif: 'https://i.gifer.com/NsJt.gif'}, 
        {title: 'Logan', id: 'tt3315342', gif: 'https://i.gifer.com/L8iS.gif'}, 
        {title: 'The Terminator', id: 'tt0088247', gif: 'https://i.gifer.com/3jaE.gif'}, 
        {title: 'No Country For Old Men', id: 'tt0477348'}, 
        {title: 'Titanic', id: 'tt0120338', gif: 'https://i.gifer.com/VK11.gif'}, 
        {title: 'The Exorcist', id: 'tt0070047'}, 
        {title: 'Black Panther', id: 'tt9114286'}, 
        {title: 'Shaun Of The Dead', id: 'tt0365748', gif: 'https://i.gifer.com/aus.gif'}, 
        {title: 'Lost In Translation', id: 'tt0335266', gif: 'https://i.gifer.com/SLL.gif'}, 
        {title: 'Thor: Ragnarok', id: 'tt3501632', gif: 'https://i.gifer.com/7Bbe.gif'}, 
        {title: 'The Usual Suspects', id: 'tt0114814', gif: 'https://i.gifer.com/8B6a.gif'}, 
        {title: 'American Psycho', id: 'tt0144084', gif: 'https://i.gifer.com/1J4X.gif'}, 
        {title: 'In The Mood For Love', id: 'tt0118694', gif: 'https://i.gifer.com/CefY.gif'}, 
        {title: 'Star Wars: Return Of The Jedi', id: 'tt0086190', gif: 'https://i.gifer.com/1JGk.gif'}, 
        {title: 'Arrival', id: 'tt2543164', gif: 'https://i.gifer.com/7dQ3.gif'}, 
        {title: 'A Quiet Place', id: 'tt6644200'}, 
        {title: 'Trainspotting', id: 'tt0117951', gif: 'https://i.gifer.com/7MW.gif'}, 
        {title: 'Mulholland Drive', id: 'tt0166924', gif: 'https://i.gifer.com/EHvs.gif'}, 
        {title: 'Up', id: 'tt1049413', gif: 'https://i.gifer.com/44qw.gif'}, 
        {title: 'Spider-Man: Into The Spider-Verse', id: 'tt4633694', gif: 'https://i.gifer.com/fyGg.gif'}, 
        {title: 'Inglourious Basterds', id: 'tt0361748', gif: 'https://i.gifer.com/3bfv.gif'}, 
        {title: 'Lady Bird', id: 'tt4925292'}, 
        {title: 'One Flew Over The Cuckoo`s Nest', id: 'tt0073486', gif: 'https://i.gifer.com/D0kH.gif'}, 
        {title: 'La La Land', id: 'tt3783958', gif: 'https://i.gifer.com/ma.gif'}, 
        {title: 'Get Out', id: 'tt5052448'}, 
        {title: 'Pan`s Labyrinth', id: 'tt0457430', gif: 'https://i.gifer.com/2LH7.gif'}, 
        {title: 'Hot Fuzz', id: 'tt0425112', gif: 'https://i.gifer.com/7vZn.gif'}, 
        {title: 'Moonlight', id: 'tt4975722'}, 
        {title: 'Guardians Of The Galaxy', id: 'tt2015381', gif: 'https://i.gifer.com/Rjh.gif'}, 
        {title: 'Blade Runner 2049', id: 'tt1856101', gif: 'https://i.gifer.com/YOD.gif'}, 
        {title: 'The Social Network', id: 'tt1285016', gif: 'https://i.gifer.com/4nvy.gif'}, 
        {title: 'Taxi Driver', id: 'tt0075314', gif: 'https://i.gifer.com/VUlZ.gif'}, 
        {title: 'Saving Private Ryan', id: 'tt0120815', gif: 'https://i.gifer.com/3lYi.gif'}, 
        {title: 'Forrest Gump', id: 'tt0109830', gif: 'https://i.gifer.com/fxz8.gif'}, 
        {title: 'Point Break', id: 'tt0102685', gif: 'https://i.gifer.com/Xq30.gif'}, 
        {title: 'Whiplash', id: 'tt2582802', gif: 'https://i.gifer.com/JmYL.gif'}, 
        {title: 'Ghostbusters', id: 'tt4513678', gif: 'https://i.gifer.com/4nc.gif'}, 
        {title: 'Do The Right Thing', id: 'tt0097216', gif: 'https://i.gifer.com/TfM6.gif'}, 
        {title: 'Schindler`s List', id: 'tt0108052', gif: 'https://i.gifer.com/8lZf.gif'}, 
        {title: 'The Big Lebowski', id: 'tt0118715', gif: 'https://i.gifer.com/fzf.gif'}, 
        {title: 'There Will Be Blood', id: 'tt0469494', gif: 'https://i.gifer.com/1HJM.gif'}, 
        {title: 'The Silence Of The Lambs', id: 'tt0102926'}, 
        {title: 'Gladiator', id: 'tt0172495', gif: 'https://i.gifer.com/GbJY.gif'}, 
        {title: 'Eternal Sunshine Of The Spotless Mind', id: 'tt0338013', gif: 'https://i.gifer.com/R2lz.gif'}, 
        {title: 'The Shining', id: 'tt0081505', gif: 'https://i.gifer.com/2Yht.gif'}, 
        {title: 'The Lord Of The Rings: The Two Towers', id: 'tt0167261', gif: 'https://i.gifer.com/V7lb.gif'}, 
        {title: 'Interstellar', id: 'tt0816692', gif: 'https://i.gifer.com/72sG.gif'}, 
        {title: 'Heat', id: 'tt0113277'}, 
        {title: 'Indiana Jones And The Last Crusade', id: 'tt0082971', gif: ''}, 
        {title: 'Die Hard', id: 'tt0095016', gif: 'https://i.gifer.com/Yyzx.gif'}, 
        {title: 'Fight Club', id: 'tt0137523', gif: 'https://i.gifer.com/Tq0.gif'}, 
        {title: 'Avengers: Endgame', id: 'tt4154796', gif: 'https://i.gifer.com/fycX.gif'}, 
        {title: 'The Matrix', id: 'tt0133093', gif: 'https://i.gifer.com/NvL.gif'}, 
        {title: 'Inception', id: 'tt1375666', gif: 'https://i.gifer.com/NjSO.gif'}, 
        {title: 'Parasite', id: 'tt6751668'}, 
        {title: 'Jurassic Park', id: 'tt0107290', gif: 'https://i.gifer.com/TnCA.gif'}, 
        {title: 'Back To The Future', id: 'tt0088763', gif: 'https://i.gifer.com/KwzL.gif'}, 
        {title: 'Mad Max: Fury Road', id: 'tt1392190', gif: 'https://i.gifer.com/1rkh.gif'}, 
        {title: 'Star Wars', id: 'tt0076759', gif: 'https://i.gifer.com/9Nq7.gif'}, 
        {title: 'Goodfellas', id: 'tt0099685', gif: 'https://i.gifer.com/DXo2.gif'}, 
        {title: 'Raiders Of The Lost Ark', id: 'tt0082971', gif: 'https://i.gifer.com/2lP3.gif'}, 
        {title: 'Avengers: Infinity War', id: 'tt4154756', gif: 'https://i.gifer.com/fyf6.gif'}, 
        {title: 'Pulp Fiction', id: 'tt0110912', gif: 'https://i.gifer.com/Lvy.gif'}, 
        {title: 'Jaws', id: 'tt0073195', gif: 'https://i.gifer.com/1HlA.gif'}, 
        {title: 'The Shawshank Redemption', id: 'tt0111161', gif: 'https://i.gifer.com/Eub8.gif'}, 
        {title: 'The Dark Knight', id: 'tt0468569', gif: 'https://i.gifer.com/4yCe.gif'}
    ];

    const min = 0,
          max = films.length-1;
    let rand = Math.floor(min + Math.random() * (max + 1 - min));
    if(quantity > 1) {
        let endArr = rand > films.length - quantity ? rand - quantity : rand;
        return films.slice(endArr, endArr + quantity)
    } 

    return films[rand];
}